<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Dashboard
            </h1>
            <div class="d-flex">
                <router-link :to="{name:'fulfillment'}" class="btn btn-primary btn-payout">
                    Uninvoiced Balance: ${{ $helper.numberFormat(unpaid_fulfill) }}
                </router-link>
                <div class="ml-auto hide-phone">
                    <button class="btn btn-outline-secondary mr-2" @click="reload">
                        <i class="fi fi-repeat"/>
                    </button>
                    <div class="btn-group" role="group" aria-label="Preiod">
                        <button type="button" :class="{active: period == 'TODAY'}" class="btn btn-outline-secondary"
                                @click="period = 'TODAY'">
                            Today
                        </button>
                        <button type="button" :class="{active: period == 'YESTERDAY'}" class="btn btn-outline-secondary"
                                @click="period = 'YESTERDAY'">
                            Yesterday
                        </button>
                        <button type="button" :class="{active: period == 'LAST_7_DAYS'}"
                                class="btn btn-outline-secondary" @click="period = 'LAST_7_DAYS'">
                            Last 7
                            days
                        </button>
                        <button type="button" :class="{active: period == 'LAST_30_DAYS'}"
                                class="btn btn-outline-secondary" @click="period = 'LAST_30_DAYS'">
                            Last 30
                            days
                        </button>

                        <!-- <button type="button" :class="{active: period == 'SAME_DAY_LAST_WEEK'}"
                                   @click="period = 'SAME_DAY_LAST_WEEK'" class="btn btn-outline-secondary">
                               Same day last week
                           </button>-->
                        <button type="button" :class="{active: period == 'ALL_TIME'}" class="btn btn-outline-secondary"
                                @click="period = 'ALL_TIME'">
                            All time
                        </button>
                  <!--      <button type="button" :class="{active: period == 'CUSTOM'}" class="btn btn-outline-secondary"
                                @click="period = 'CUSTOM'">
                            Custom
                        </button>-->
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <card-box class="text-center">
                        <strong>REVENUE</strong> <br>
                        <strong>${{ revenue }}</strong> revenue <br>
                        <strong>${{ profit }}</strong> profit
                    </card-box>
                </div><!-- end col -->


                <div class="col">
                    <card-box class="text-center">
                        <strong>PURCHASES</strong> <br>
                        <strong>{{ totalItem }}</strong> total <br>
                        <strong>{{ uniqueItem }}</strong> unique
                    </card-box>
                </div><!-- end col -->


                <div class="col">
                    <card-box class="text-center">
                        <strong>STORE VISITS</strong> <br>
                        <strong>{{ visit }}</strong> total <br>
                        <strong>{{ visiter }}</strong> unique
                    </card-box>
                </div><!-- end col -->

                <div class="col">
                    <card-box class="text-center">
                        <strong>CONVERSION RATE</strong> <br>
                        {{ conversion }} % <br>
                        <br>
                    </card-box>
                </div><!-- end col -->
            </div>
            <!-- end row -->

            <card-box>
                <h4 class="header-title m-t-0 m-b-30">
                    Last 10 solds
                </h4>
                <table class="table table-responsive table-sm w-100 d-md-table d-block">
                    <tr>
                        <th/>
                        <th>NAME</th>
                        <th>QUANTITY</th>
                        <th>UTM SOURCE</th>
                        <th>DATE</th>
                    </tr>
                    <tr v-for="(item) in solds">
                        <td class="thumb-sm">
                            <img :src="item.thumb" class="thumb-sm">
                        </td>
                        <td><a :href="$helper.url(item.id,item.name)">{{ item.name }}</a></td>
                        <td class="text-center">
                            {{ item.qty }}
                        </td>
                        <td style="max-width: 200px">
                            {{ item.utm_source }}
                        </td>
                        <td width="100">
                            {{ item.date }}
                        </td>
                    </tr>
                </table>
            </card-box>


            <card-box>
                <h4 class="header-title m-t-0 m-b-30">
                    Last 10 add cart
                </h4>
                <table class="table table-responsive table-sm w-100 d-md-table d-block">
                    <tr>
                        <th/>
                        <th>NAME</th>
                        <th>QUANTITY</th>
                        <th>UTM SOURCE</th>
                        <th>DATE</th>
                    </tr>
                    <tr v-for="(item) in addCart">
                        <td class="thumb-sm">
                            <img :src="item.thumb" class="thumb-sm">
                        </td>
                        <td><a :href="$helper.url(item.id,item.name)">{{ item.name }}</a></td>
                        <td class="text-center">
                            {{ item.qty }}
                        </td>
                        <td>{{ item.utm_source }}</td>

                        <td width="100">
                            {{ item.date }}
                        </td>
                    </tr>
                </table>
            </card-box>


            <div class="card-box">
                <h4 class="header-title m-t-0 m-b-30">
                    Visits - last 30 days
                </h4>


                <div class="chart-container">
                    <chart :update="renderTraffic" :chart-config="trafficChartConfig"/>
                </div>
            </div>

            <div class="card-box">
                <h4 class="header-title m-t-0 m-b-30">
                    Purchases - last 30 days
                </h4>


                <div class="chart-container">
                    <chart :update="renderOrder" :chart-config="orderChartConfig"/>
                </div>
            </div>
        </div> <!-- container -->
    </div>
</template>

<script>
    import Chart from "@/components/Chart";
    import CardBox from "@/components/CardBox";

    export default {
        name: "Home",
        components: {CardBox, Chart},
        data: function () {
            return {
                period: 'TODAY',
                renderOrder: '',
                renderTraffic: '',
                chartConfig: {
                    type: 'pie',
                    data: {
                        labels: ['HTML', 'JavaScript', 'CSS'],
                        datasets: [{
                            data: [56.6, 37.7, 4.1],
                            backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
                            hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: !this.isMobile,
                        legend: {
                            position: 'bottom',
                            display: true
                        }
                    }
                },
                trafficChartConfig: {
                    type: 'line',
                    data: {
                        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                        datasets: [
                            {
                                label: 'Vistors',
                                backgroundColor:
                                    'rgba(157,174,92, 0.2)'

                                ,
                                borderColor:
                                    'rgba(157,174,92,1)'

                                ,
                                lineTension: 0,
                                borderWidth: 2,

                                data: [65, 59, 80, 81, 56, 55, 40]
                            },
                            {
                                label: 'Visit',
                                backgroundColor:
                                    'rgba(157,174,92, 0.2)'

                                ,
                                borderColor:
                                    'rgba(157,174,92,1)'

                                ,
                                borderDash: [10, 5],
                                lineTension: 0,
                                borderWidth: 2,

                                data: [65, 59, 80, 81, 56, 55, 40]
                            }
                        ]
                    },
                    options: {
                        scales: {
                            xAxes: [{
                                type: 'time',
                                distribution: 'series',
                                /*stacked: true*/
                            }],
                            yAxes: [{
                                display: true,
                                /*stacked: true,*/
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Total'
                                }
                            }]
                        }
                    }
                },
                orderChartConfig: {
                    type: 'line',
                    data: {
                        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                        datasets: [
                            {
                                label: 'Order',
                                backgroundColor:
                                    'rgba(157,174,92, 0.2)'

                                ,
                                borderColor:
                                    'rgba(157,174,92,1)'

                                ,
                                lineTension: 0,
                                borderWidth: 2,

                                data: [65, 59, 80, 81, 56, 55, 40]
                            },
                            {
                                label: 'Item',
                                backgroundColor:
                                    'rgba(157,174,92, 0.2)'

                                ,
                                borderColor:
                                    'rgba(157,174,92,1)'

                                ,
                                borderDash: [10, 5],
                                lineTension: 0,
                                borderWidth: 2,

                                data: [65, 59, 80, 81, 56, 55, 40]
                            }
                        ]
                    },
                    options: {
                        scales: {
                            xAxes: [{
                                type: 'time',
                                distribution: 'series',

                                /* stacked: true*/
                            }],
                            yAxes: [{
                                display: true,
                                /*stacked: true,*/
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Total'
                                }
                            }]
                        }
                    }
                },

                analytic: {
                    visiter: 0,
                    visit: 0,
                    revenue: 0,
                    base_cost: 0,
                    total: 0,
                    unique: 0,
                    profit: 0
                },
                unpaid_fulfill: 0,
                solds: [],
                addCart: []
            }

        },
        computed: {
            visiter: function () {
                return this.$helper.numberFormat(this.analytic.visiter)
            },
            visit: function () {
                return this.$helper.numberFormat(this.analytic.visit)
            },
            revenue: function () {
                return this.$helper.numberFormat(this.analytic.revenue)
            },
            profit: function () {
                return this.$helper.numberFormat(this.analytic.profit)
            },
            totalItem: function () {
                return this.$helper.numberFormat(this.analytic.total)
            },
            uniqueItem: function () {
                return this.$helper.numberFormat(this.analytic.unique)
            },
            conversion: function () {
                return Math.round((this.analytic.total / this.analytic.visiter) * 100000) / 1000
            }

        },
        watch: {
            'period': function () {
                this.overview()
                this.traffic()
            }
        },
        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'home')
            this.overview()
            this.traffic()
            this.last()
            this.order()
            this.fulfillment()

        },
        methods: {
            fulfillment: function () {
                let vm = this
                this.$http.get(this.$config.api + 'statistic/fulfillment').then(function (res) {
                    vm.unpaid_fulfill = res.data.total
                })
            },
            reload: function () {
                this.fulfillment()
                this.overview()
                this.traffic()
                this.last()
                this.order()
            },
            last: function () {
                let vm = this
                this.$http.get(this.$config.api + 'statistic/last').then(function (res) {
                    vm.solds = res.data.solds
                    vm.addCart = res.data.addcart
                })

            },
            overview: function () {
                let vm = this
                this.$http.get(this.$config.api + 'statistic?period=' + this.period).then(function (res) {
                    vm.analytic.revenue = res.data.revenue || 0;
                    vm.analytic.total = res.data.total || 0;
                    vm.analytic.unique = res.data.unique || 0;
                    vm.analytic.base_cost = res.data.base_cost || 0;
                    vm.analytic.profit = res.data.profit || 0;
                })

            },
            traffic: function () {
                let vm = this
                this.$http.get(this.$config.api + 'statistic/traffic/summary?period=' + this.period).then(function (res) {
                    vm.analytic.visiter = res.data.visiter || 0;
                    vm.analytic.visit = res.data.visit || 0;
                })

            },
            order: function () {
                let vm = this
                this.$http.get(this.$config.api + 'statistic/order').then(function (res) {
                    let labels = []
                    let data = []
                    let items = []
                    for (let i = 0; i < res.data.length; i++) {
                        labels.push(res.data[i].day)
                        data.push(parseInt(res.data[i].total))
                        items.push(parseInt(res.data[i].item))
                    }

                    vm.$set(vm.orderChartConfig.data, 'labels', labels)
                    vm.$set(vm.orderChartConfig.data.datasets[0], 'data', data)
                    vm.$set(vm.orderChartConfig.data.datasets[1], 'data', items)


                    vm.renderOrder = new Date().toUTCString()
                    // vm.barChartConfig = null
                })

                this.$http.get(this.$config.api + 'statistic/traffic').then(function (res) {
                    let labels = []
                    let data = []
                    let items = []
                    for (let i = 0; i < res.data.length; i++) {
                        labels.push(res.data[i].day)
                        data.push(parseInt(res.data[i].total))
                        items.push(parseInt(res.data[i].item))
                    }
                    vm.$set(vm.trafficChartConfig.data, 'labels', labels)
                    vm.$set(vm.trafficChartConfig.data.datasets[0], 'data', data)
                    vm.$set(vm.trafficChartConfig.data.datasets[1], 'data', items)

                    vm.renderTraffic = new Date().toUTCString()
                })
            }

        }


    }
</script>

<style scoped>

</style>